// GlobalStateContext.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  daysDataPicker: 90,
  isActiveGlobalCheckbox: false,
  quantityMainTableRequests: 1,
};

const findConfigurationValueByKey = (configurations, key) => {
  const configuration = configurations?.data?.find(
    (config) => config.configurationKey === key
  );
  return configuration ? configuration.configurationValue : null;
};

export const configurationSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setConfiguration: (state, action) => {
      state.daysDataPicker = findConfigurationValueByKey(
        action.payload,
        "DaysDateFilter"
      );
      state.isActiveGlobalCheckbox = findConfigurationValueByKey(
        action.payload,
        "EnableMainTableGlobalCheckbox"
      );
      state.quantityMainTableRequests = findConfigurationValueByKey(
        action.payload,
        "QuantityMainTableRequests"
      );
    },
  },
});

export const { setConfiguration } = configurationSlice.actions;
export default configurationSlice.reducer;
